import axios from 'axios'
import {decode} from 'jsog'

const toData = response => decode(response.data)

export function getFeedbackQuestions(uuid): Promise {
  return axios.get(`/bw/feedback/init/${uuid}`).then(toData)
}

export function getFeedbackScan(uuid): Promise {
  return axios.get(`/bw/feedback/scan/${uuid}`).then(toData)
}

export function getFeedbackAnswers(uuid): Promise {
  return axios.get(`/bw/feedback/answer/${uuid}`).then(toData)
}

export function upsertFeedbackAnswer(uuid, data): Promise {
  return axios.post(`/bw/feedback/answer/${uuid}`, data).then(toData)
}

export function deleteFeedback(uuid): Promise {
  return axios.delete(`/bw/feedback/${uuid}`).then(toData)
}


// WEBPACK FOOTER //
// ./src/services/feedback-service.js